var elPlansV2 = {
  load:function(holderID,options){
    this.options = options;
    this.holderID = this.holderID;
    this.holder = document.getElementById(holderID);
    this.planDivs = this.holder.querySelectorAll("div[data-plan]");
    this.planScroll = this.holder.parentNode;
    this.button = document.getElementById("planSelectSubmit");
    this.selectable = true;
    this.select(options.plan);
    this.events();
  },
  events:function(){
    this.planDivs.forEach(p=>{
      p.addEventListener("click",(e)=>{
          this.select(e.currentTarget.getAttribute("data-plan"));
      });
    });

    this.button.addEventListener("click",(e)=>{
      e.preventDefault();
      if(parseFloat(this.plan.price) == 0){

        elLoader.show("Submitting Event for Approval");
        fetch(ELAJAX.url+"submit/",{
          method:"POST",
          headers:{
            "Content-Type":"application/json",
            "Accept":"application/json"
          },
          body:JSON.stringify({
            'id':hh2020Login.userData.id,
            'token':hh2020Login.userData.token,
            'eventHash':EVENTHASH
          })
        }).then(res=>{
          parent.location = ELAJAX.homeURL+"event/"+EVENTHASH+"/posted/";
        });
      }
      else{
        elLoader.show("Redirecting to Payment Form");
        parent.location = ELAJAX.homeURL + "payment/"+EVENTHASH+"/"+this.planID;
      }
    });
  },
  focusPlan:function(plan){

    this.planDivs.forEach((d,index)=>{

      if(d.getAttribute("data-plan") == plan){
        d.style.display = "block";
        d.classList.add("static");
      }
      else{
        d.style.display = "none";
      }
    });
    this.button.style.display = "none";
  },
  select:function(plan){
    if(!this.selectable) return;
    this.planID = plan;


    this.planDivs.forEach((d,index)=>{

      if(d.getAttribute("data-plan") == plan){

        if(index > 0){
          this.planScroll.scrollTo({left:600,behavior:"smooth"});
        }
        else{
          this.planScroll.scrollTo({left:0,behavior:"smooth"});
        }

        d.classList.add("selected");
        this.plan = {
          price:d.getAttribute("data-price"),
          priceString:d.getAttribute("data-priceString"),
          name:d.getAttribute("data-name"),
          id:d.getAttribute("data-plan"),
          description:d.getAttribute("data-description")
        };

        if(parseFloat(this.plan.price) == 0){
          this.button.innerHTML = "Submit for Approval";
          this.button.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward Circle</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M262.62 336L342 256l-79.38-80M330.97 256H170"/><path d="M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>';
        }
        else{
          this.button.innerHTML = "Continue to Payment";
          this.button.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward Circle</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M262.62 336L342 256l-79.38-80M330.97 256H170"/><path d="M256 448c106 0 192-86 192-192S362 64 256 64 64 150 64 256s86 192 192 192z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>';
        }
        this.button.click();

      }
      else{
        d.classList.remove("selected");
      }

    });

  }
};
